
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a2031160443 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","¤¤¤",{".":",",",":" ","%":"%","+":"+","-":"−","E":"×10^","‰":"‰"},]);
Globalize.b1458204999 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","¤¤¤",{".":",",",":" ","%":"%","+":"+","-":"−","E":"×10^","‰":"‰"},]);
Globalize.b1165082887 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","¤¤¤",{".":",",",":" ","%":"%","+":"+","-":"−","E":"×10^","‰":"‰"},]);
Globalize.b1228670462 = numberParserFn([{",":"."," ":",","%":"%","+":"+","-":"-","×10^":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^¤¤¤/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a136552493 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.a546271748 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa fler datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1036067690 = messageFormatterFn((function(  ) {
  return function(d) { return "valda"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b798138761 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämtar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b843832504 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a402504606 = messageFormatterFn((function(  ) {
  return function(d) { return "Öppnas i ett nytt fönster"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1326387940 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1254600983 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mindre"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b57740901 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1855508568 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mindre"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b607323965 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts. Ange utcheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1813651630 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts. Klicka på " + d["1"] + " för att spara datumen och stänga datumväljaren."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b295530670 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts. Nuvarande incheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a170510223 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts. Nuvarande utcheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a784515301 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", datum avaktiverat"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a184632738 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", nuvarande månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a931615107 = messageFormatterFn((function(  ) {
  return function(d) { return "Nu visas " + d["0"] + " och " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a95831175 = messageFormatterFn((function(  ) {
  return function(d) { return "Datumväljaren är öppen. Välj datum i tabellen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1283011609 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, stäng datumväljaren utan att spara ändringarna. Eller välj datum i tabellen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1399890615 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa valda datum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a572685922 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara ändringar och stäng datumväljaren."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2140388485 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " nätter";}, one: function() { return number(d["0"]) + " natt";}, two: function() { return number(d["0"]) + " nätter";}, few: function() { return number(d["0"]) + " nätter";}, many: function() { return number(d["0"]) + " nätter";}, other: function() { return number(d["0"]) + " nätter";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1641604469 = messageFormatterFn((function(  ) {
  return function(d) { return "Incheckning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1758815140 = messageFormatterFn((function(  ) {
  return function(d) { return "Utcheckning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1364764445 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1192637444 = messageFormatterFn((function(  ) {
  return function(d) { return "Klar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b988140638 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a971265624 = messageFormatterFn((function(  ) {
  return function(d) { return "Redigera incheckningsdatum i tabellen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1081349673 = messageFormatterFn((function(  ) {
  return function(d) { return "Redigera utcheckningsdatum i tabellen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a327885608 = messageFormatterFn((function(  ) {
  return function(d) { return "valt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2043424517 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts. Stäng kalendern eller gå vidare för att ändra datumet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1218709453 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " till " + d["1"] + " har valts. Stäng kalendern eller gå vidare för att ändra datum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b403825709 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts. " + d["1"] + ". Stäng kalendern eller gå vidare för att ändra datumet."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1241646821 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " till " + d["1"] + " har valts. " + d["2"] + ". Stäng kalendern eller gå vidare för att ändra datum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a496505964 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj incheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b200590427 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj utcheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1097664044 = messageFormatterFn((function(  ) {
  return function(d) { return "tomt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b55664590 = messageFormatterFn((function(  ) {
  return function(d) { return "Föregående månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1201166442 = messageFormatterFn((function(  ) {
  return function(d) { return "Nästa månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a770715577 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoppa till knappen " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1503395247 = messageFormatterFn((function(  ) {
  return function(d) { return "Från " + d["0"] + " till " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b763033204 = messageFormatterFn((function(  ) {
  return function(d) { return "Datum har rensats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b351294239 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "det finns " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " resultat";}, one: function() { return number(d["0"]) + " resultat";}, two: function() { return number(d["0"]) + " resultat";}, few: function() { return number(d["0"]) + " resultat";}, many: function() { return number(d["0"]) + " resultat";}, other: function() { return number(d["0"]) + " resultat";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2028828726 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " resultat tillgängliga";}, one: function() { return number(d["1"]) + " resultat tillgängligt";}, two: function() { return number(d["1"]) + " resultat tillgängliga";}, few: function() { return number(d["1"]) + " resultat tillgängliga";}, many: function() { return number(d["1"]) + " resultat tillgängliga";}, other: function() { return number(d["1"]) + " resultat tillgängliga";} }) + " för “" + d["0"] + "”. Använd pilknapparna eller svep för att navigera i listan."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1668340318 = messageFormatterFn((function(  ) {
  return function(d) { return "Öppen sökning på " + d["0"] + ". Skriv in en sökterm."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1352704815 = messageFormatterFn((function(  ) {
  return function(d) { return "Du valde " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1796951150 = messageFormatterFn((function(  ) {
  return function(d) { return "Menyn har stängts."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b407352396 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Sökning på " + d["0"] + " öppen, visar för närvarande " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " förslag";}, one: function() { return number(d["1"]) + " förslag";}, two: function() { return number(d["1"]) + " förslag";}, few: function() { return number(d["1"]) + " förslag";}, many: function() { return number(d["1"]) + " förslag";}, other: function() { return number(d["1"]) + " förslag";} }) + " för " + d["2"] + ". Navigera i listan nedan."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a734414083 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Sökning för " + d["0"] + " öppen, visar " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " förslag";}, one: function() { return number(d["1"]) + " förslag";}, two: function() { return number(d["1"]) + " förslag";}, few: function() { return number(d["1"]) + " förslag";}, many: function() { return number(d["1"]) + " förslag";}, other: function() { return number(d["1"]) + " förslag";} }) + ". Ange sökterm eller navigera i listan nedan."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1275610785 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Sökning för " + d["0"] + " öppen, nuvarande val " + d["1"] + " . Visar " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " förslag";}, one: function() { return number(d["1"]) + " förslag";}, two: function() { return number(d["1"]) + " förslag";}, few: function() { return number(d["1"]) + " förslag";}, many: function() { return number(d["1"]) + " förslag";}, other: function() { return number(d["1"]) + " förslag";} }) + " för " + d["3"] + ". Navigera i listan nedan."; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b647345883 = messageFormatterFn((function(  ) {
  return function(d) { return "Klart"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1829420420 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa alla"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1880808977 = messageFormatterFn((function(  ) {
  return function(d) { return "Valda alternativ"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a402806844 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " togs bort."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1636237731 = messageFormatterFn((function(  ) {
  return function(d) { return "Alla valda alternativ togs bort."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a852036340 = messageFormatterFn((function(  ) {
  return function(d) { return "Du har angett data i textfältet. Sök eller välj bland kategoriförslag nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1409413803 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök efter \"" + d["0"] + "\""; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1651585324 = messageFormatterFn((function(  ) {
  return function(d) { return "Inga resultat för \"" + d["0"] + "\""; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a668068906 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a433443795 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a530730985 = messageFormatterFn((function(  ) {
  return function(d) { return "Sevärdhet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2118757774 = messageFormatterFn((function(  ) {
  return function(d) { return "I närheten"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1665244849 = messageFormatterFn((function(  ) {
  return function(d) { return "Testa \"" + d["0"] + "\""; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a379247990 = messageFormatterFn((function(  ) {
  return function(d) { return "Region/stad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b227997130 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1085216882 = messageFormatterFn((function(  ) {
  return function(d) { return "Sevärdhet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b814414625 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a155788063 = messageFormatterFn((function(  ) {
  return function(d) { return "Adress"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1848122839 = messageFormatterFn((function(  ) {
  return function(d) { return "Tågstation"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b420264474 = messageFormatterFn((function(  ) {
  return function(d) { return "Tunnelbanestation"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1572611466 = messageFormatterFn((function(  ) {
  return function(d) { return "Platser i närheten"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1006748607 = messageFormatterFn((function(  ) {
  return function(d) { return "Senaste sökningar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a570462757 = messageFormatterFn((function(  ) {
  return function(d) { return "Andra har även sökt efter:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b284038480 = messageFormatterFn((function(  ) {
  return function(d) { return "Upptäck trendande destinationer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1338223420 = messageFormatterFn((function(  ) {
  return function(d) { return "Populära destinationer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1542869320 = messageFormatterFn((function(  ) {
  return function(d) { return "Trendande destinationer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a969322938 = messageFormatterFn((function(  ) {
  return function(d) { return "Din plats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1806861577 = messageFormatterFn((function(  ) {
  return function(d) { return "Platsdelning är avaktiverat"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1370148345 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan inte avgöra din plats. Aktivera platstjänster för att vi ska kunna avgöra din plats, eller ange en destination."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1117891403 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " rum";}, one: function() { return number(d["0"]) + " rum";}, two: function() { return number(d["0"]) + " rum";}, few: function() { return number(d["0"]) + " rum";}, many: function() { return number(d["0"]) + " rum";}, other: function() { return number(d["0"]) + " rum";} }) + ", " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " gäster";}, one: function() { return number(d["1"]) + " gäst";}, two: function() { return number(d["1"]) + " gäster";}, few: function() { return number(d["1"]) + " gäster";}, many: function() { return number(d["1"]) + " gäster";}, other: function() { return number(d["1"]) + " gäster";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b174475221 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gäster";}, one: function() { return number(d["0"]) + " gäst";}, two: function() { return number(d["0"]) + " gäster";}, few: function() { return number(d["0"]) + " gäster";}, many: function() { return number(d["0"]) + " gäster";}, other: function() { return number(d["0"]) + " gäster";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b923146791 = messageFormatterFn((function(  ) {
  return function(d) { return "Värdet av fältet " + d["0"] + " är nu " + d["1"] + ". Värdet av fältet " + d["2"] + " är nu " + d["3"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1507340408 = messageFormatterFn((function(  ) {
  return function(d) { return "Byt ut fälten " + d["0"] + " och " + d["1"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b988810581 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1303152720 = messageFormatterFn((function(  ) {
  return function(d) { return "Dölj lösenord"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b71304983 = messageFormatterFn((function(  ) {
  return function(d) { return "Nu visas " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a911057676 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " av " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b482088918 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild " + d["0"] + " av " + d["1"] + ". " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1579863257 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämta nästa bild"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1206725469 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämta föregående bild"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1103044119 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Visa " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " bilder";}, one: function() { return number(d["0"]) + " bild";}, two: function() { return number(d["0"]) + " bilder";}, few: function() { return number(d["0"]) + " bilder";}, many: function() { return number(d["0"]) + " bilder";}, other: function() { return number(d["0"]) + " bilder";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2022732482 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Visa " + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " bilder";}, one: function() { return number(d["0"]) + " bild";}, two: function() { return number(d["0"]) + " bilder";}, few: function() { return number(d["0"]) + " bilder";}, many: function() { return number(d["0"]) + " bilder";}, other: function() { return number(d["0"]) + " bilder";} }) + " för " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1891402491 = messageFormatterFn((function(  ) {
  return function(d) { return "Klart:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1973121001 = messageFormatterFn((function(  ) {
  return function(d) { return "Nu:"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2102240425 = messageFormatterFn((function(  ) {
  return function(d) { return "Steg " + d["0"] + " av " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1100161755 = messageFormatterFn((function(  ) {
  return function(d) { return "Steg " + d["0"] + " av " + d["1"] + ":"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1610895386 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild " + d["0"] + " av " + d["1"] + ". " + d["2"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b200033821 = messageFormatterFn((function(  ) {
  return function(d) { return "Nästa bild"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a636984671 = messageFormatterFn((function(  ) {
  return function(d) { return "Föregående bild"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b319713297 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", öppna i fullskärmsläge"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b883172539 = messageFormatterFn((function(  ) {
  return function(d) { return "Artikel " + d["0"] + ", öppna i fullskärmsläge"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b900554427 = messageFormatterFn((function(  ) {
  return function(d) { return "Nuvarande sida"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b599523317 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa fler länkstigar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b637344433 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa färre länkstigar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1683322610 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " procent har laddats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a511341037 = messageFormatterFn((function(  ) {
  return function(d) { return "Laddar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b458122845 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a280612474 = messageFormatterFn((function(  ) {
  return function(d) { return "Ett fel har inträffat."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a954219998 = messageFormatterFn((function(  ) {
  return function(d) { return "Prova att titta på videon på www.youtube.com eller aktivera Javascript om det är avaktiverat i din webbläsare."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2099981158 = messageFormatterFn((function(  ) {
  return function(d) { return "Spela upp video"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1425691370 = messageFormatterFn((function(  ) {
  return function(d) { return "Pausa videon"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b950355346 = messageFormatterFn((function(  ) {
  return function(d) { return "Videon laddas"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1035996636 = messageFormatterFn((function(  ) {
  return function(d) { return "360-graders bild"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1405601026 = messageFormatterFn((function(  ) {
  return function(d) { return "Detta är en 360-graders bild. Använd kontroll- och piltangenterna för att flytta runt den"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1406385969 = messageFormatterFn((function(  ) {
  return function(d) { return "Visar: " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b113550256 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttat vänster. Placering: " + d["0"] + " grader"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1920123849 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttat höger. Placering: " + d["0"] + " grader"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b294813340 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttat upp."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b332847573 = messageFormatterFn((function(  ) {
  return function(d) { return "Flyttat ner."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1628458012 = messageFormatterFn((function(  ) {
  return function(d) { return "Du är längst upp"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1443012626 = messageFormatterFn((function(  ) {
  return function(d) { return "Du är längst ner"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1183674086 = messageFormatterFn((function(  ) {
  return function(d) { return "Markera alla rader"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a289575941 = messageFormatterFn((function(  ) {
  return function(d) { return "Avmarkera alla rader"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a652918421 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortera i fallande ordning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1840622607 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortera i stigande ordning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2031784063 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolumnen visas nu i fallande ordning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1313382151 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolumnen visas nu i stigande ordning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a164990433 = messageFormatterFn((function(  ) {
  return function(d) { return "Expandera rad " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b573584320 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Visar " + d["0"] + " av " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " objekt";}, one: function() { return number(d["1"]) + " objekt";}, two: function() { return number(d["1"]) + " objekt";}, few: function() { return number(d["1"]) + " objekt";}, many: function() { return number(d["1"]) + " objekt";}, other: function() { return number(d["1"]) + " objekt";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1537565296 = messageFormatterFn((function(  ) {
  return function(d) { return "dina nuvarande månader är " + d["0"] + " " + d["1"] + " och " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1406965352 = messageFormatterFn((function(  ) {
  return function(d) { return "din nuvarande månad är " + d["0"] + " " + d["1"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a31496813 = messageFormatterFn((function(  ) {
  return function(d) { return "dina nuvarande månader är mellan " + d["0"] + " " + d["1"] + " och " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1333052232 = messageFormatterFn((function(  ) {
  return function(d) { return "Incheckningsdatum har rensats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1216834591 = messageFormatterFn((function(  ) {
  return function(d) { return "Utcheckningsdatum har rensats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1973441376 = messageFormatterFn((function(  ) {
  return function(d) { return "Datum har rensats."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1815462523 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1238444635 = messageFormatterFn((function(  ) {
  return function(d) { return "Skicka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1582266114 = messageFormatterFn((function(  ) {
  return function(d) { return "Nästa månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1127067586 = messageFormatterFn((function(  ) {
  return function(d) { return "Föregående månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1733903716 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoppa till Välj-knappen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b156443113 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoppa till knappen " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1422526456 = messageFormatterFn((function(  ) {
  return function(d) { return "Nästa månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a132303032 = messageFormatterFn((function(  ) {
  return function(d) { return "Föregående månad"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1261092991 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts som ditt incheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a475987194 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har valts som ditt utcheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1214007965 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " är inte ett giltigt incheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b599461048 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " är inte ett giltigt utcheckningsdatum."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b185378327 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " är inte tillgängligt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1289071450 = messageFormatterFn((function(  ) {
  return function(d) { return "Idag"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b188848824 = messageFormatterFn((function(  ) {
  return function(d) { return "Valt incheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a851635777 = messageFormatterFn((function(  ) {
  return function(d) { return "Valt utcheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1507309292 = messageFormatterFn((function(  ) {
  return function(d) { return "Valt datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1229473776 = messageFormatterFn((function(  ) {
  return function(d) { return "Startdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2105189033 = messageFormatterFn((function(  ) {
  return function(d) { return "Slutdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1128150730 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, stäng datumfönstret utan att spara ändringarna. Eller välj datum i tabellen nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1263419269 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " av " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1726164656 = messageFormatterFn((function(  ) {
  return function(d) { return "Tryck på Esc för att avvisa."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1436249543 = messageFormatterFn((function(  ) {
  return function(d) { return "Tryck på Esc för att stänga."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b316399480 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange en siffra som är lägre än " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b574108103 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange en siffra som är högre än " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1280094982 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange en siffra mellan " + d["0"] + " och " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1365959223 = messageFormatterFn((function(  ) {
  return function(d) { return "Obligatoriskt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a334004542 = messageFormatterFn((function(  ) {
  return function(d) { return "Transport"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1732573344 = messageFormatterFn((function(  ) {
  return function(d) { return "Boende"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1976963354 = messageFormatterFn((function(  ) {
  return function(d) { return "Resor: Semestrar, billiga flyg, flygbiljetter och flygpriser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b928436654 = messageFormatterFn((function(  ) {
  return function(d) { return "Poäng tillämpade"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1851086475 = messageFormatterFn((function(  ) {
  return function(d) { return "Poäng tillämpas ej"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1509614791 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng dialogrutan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1969198460 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1788723774 = messageFormatterFn((function(  ) {
  return function(d) { return "Incheckning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2113640561 = messageFormatterFn((function(  ) {
  return function(d) { return "Utcheckning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a427352444 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1886799546 = messageFormatterFn((function(  ) {
  return function(d) { return "Gäster"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b308275828 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b363516650 = messageFormatterFn((function(  ) {
  return function(d) { return "Mer information om " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1068504269 = messageFormatterFn((function(  ) {
  return function(d) { return "Öppnar sida med " + d["0"] + " i ny flik, gå tillbaka till den första fliken för att gå vidare"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a666470606 = messageFormatterFn((function(  ) {
  return function(d) { return "Sökresultat"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b582610943 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange destination"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1796815483 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange giltigt incheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b198132774 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange datum för din resa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a268206336 = messageFormatterFn((function(  ) {
  return function(d) { return "Utcheckningsdatum måste infalla efter incheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1218121592 = messageFormatterFn((function(  ) {
  return function(d) { return "Utcheckningsdatum måste infalla inom 28 dagar efter incheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b48717868 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange giltigt utcheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a462462658 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange antal resenärer"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a643182603 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange ålder för barn som reser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a125854299 = messageFormatterFn((function(  ) {
  return function(d) { return "Ange åldrar för barn som reser"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b339430023 = messageFormatterFn((function(  ) {
  return function(d) { return "Vistelsedatumen måste ligga inom resedatumen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1447776034 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1662691760 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " rum";}, one: function() { return number(d["0"]) + " rum";}, two: function() { return number(d["0"]) + " rum";}, few: function() { return number(d["0"]) + " rum";}, many: function() { return number(d["0"]) + " rum";}, other: function() { return number(d["0"]) + " rum";} }) + ", " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " gäster";}, one: function() { return number(d["1"]) + " gäst";}, two: function() { return number(d["1"]) + " gäster";}, few: function() { return number(d["1"]) + " gäster";}, many: function() { return number(d["1"]) + " gäster";}, other: function() { return number(d["1"]) + " gäster";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b362788288 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " rum";}, one: function() { return number(d["0"]) + " rum";}, two: function() { return number(d["0"]) + " rum";}, few: function() { return number(d["0"]) + " rum";}, many: function() { return number(d["0"]) + " rum";}, other: function() { return number(d["0"]) + " rum";} }) + ", " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " gäster";}, one: function() { return number(d["1"]) + " gäst";}, two: function() { return number(d["1"]) + " gäster";}, few: function() { return number(d["1"]) + " gäster";}, many: function() { return number(d["1"]) + " gäster";}, other: function() { return number(d["1"]) + " gäster";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b959942242 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " resenärer";}, one: function() { return number(d["1"]) + " resenär";}, two: function() { return number(d["1"]) + " resenärer";}, few: function() { return number(d["1"]) + " resenärer";}, many: function() { return number(d["1"]) + " resenärer";}, other: function() { return number(d["1"]) + " resenärer";} }) + ", husdjur"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1712922115 = messageFormatterFn((function(  ) {
  return function(d) { return "Gäster"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b932409105 = messageFormatterFn((function(  ) {
  return function(d) { return "Rum " + d["0"] + " tillagt. Redigera gästinformation nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a671255887 = messageFormatterFn((function(  ) {
  return function(d) { return "Rum borttaget. Redigera gästinformation för rum " + d["0"] + " nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b609030037 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt och stäng resenärssidan utan att spara ändringarna. Eller redigera gästinformation nedan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b681201557 = messageFormatterFn((function(  ) {
  return function(d) { return "Klar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1425620749 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara ändringarna och stäng resenärssidan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b989791335 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägg till rum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b928837336 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort rum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a150698800 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort rum " + d["0"] + " av " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b241417614 = messageFormatterFn((function(  ) {
  return function(d) { return "Ålder på barn " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1077129174 = messageFormatterFn((function(  ) {
  return function(d) { return "Rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1384125749 = messageFormatterFn((function(  ) {
  return function(d) { return "Rum " + d["0"] + " av " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1785454935 = messageFormatterFn((function(  ) {
  return function(d) { return "Barn " + d["0"] + ", ålder uppdaterad till " + d["1"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a867843919 = messageFormatterFn((function(  ) {
  return function(d) { return "Under 1 år"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1007826017 = messageFormatterFn((function(  ) {
  return function(d) { return "Barn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1865272392 = messageFormatterFn((function(  ) {
  return function(d) { return "(Från 0 till 17 år)"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1290546633 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " vuxna";}, one: function() { return number(d["0"]) + " vuxen";}, two: function() { return number(d["0"]) + " vuxna";}, few: function() { return number(d["0"]) + " vuxna";}, many: function() { return number(d["0"]) + " vuxna";}, other: function() { return number(d["0"]) + " vuxna";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a40991503 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " barn";}, one: function() { return number(d["0"]) + " barn";}, two: function() { return number(d["0"]) + " barn";}, few: function() { return number(d["0"]) + " barn";}, many: function() { return number(d["0"]) + " barn";}, other: function() { return number(d["0"]) + " barn";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a359412135 = messageFormatterFn((function(  ) {
  return function(d) { return "Vuxna"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b209876509 = messageFormatterFn((function(  ) {
  return function(d) { return "Minska antalet barn i rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1420623959 = messageFormatterFn((function(  ) {
  return function(d) { return "Minska antalet vuxna i rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a556341183 = messageFormatterFn((function(  ) {
  return function(d) { return "Öka antalet barn i rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a251679877 = messageFormatterFn((function(  ) {
  return function(d) { return "Öka antalet vuxna i rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1628751569 = messageFormatterFn((function(  ) {
  return function(d) { return "Husdjur"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b384704821 = messageFormatterFn((function(  ) {
  return function(d) { return "Husdjur inkluderade?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1221824385 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1961260337 = messageFormatterFn((function(  ) {
  return function(d) { return "Nej"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1191926587 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " har lagts till i dina listor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1889654891 = messageFormatterFn((function(  ) {
  return function(d) { return "Öppnas i ett nytt fönster"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b336906090 = messageFormatterFn((function(  ) {
  return function(d) { return "Gästrecensioner"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b816480526 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, gå tillbaka till hotellsidan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1391315802 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa tillgänglighet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1899984209 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa tillgänglighet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b470515361 = messageFormatterFn((function(  ) {
  return function(d) { return "Ändra sökningen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2072236830 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj ett senare incheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1168297094 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj ett tidigare incheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a270083201 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj ett senare utcheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1324516573 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj ett tidigare utcheckningsdatum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1725691383 = messageFormatterFn((function(  ) {
  return function(d) { return "Priset var " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a879841093 = messageFormatterFn((function(  ) {
  return function(d) { return "Priset är " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1810861846 = messageFormatterFn((function(  ) {
  return function(d) { return "Nuvarande pris: " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a859875768 = messageFormatterFn((function(  ) {
  return function(d) { return "Priset var " + d["0"] + " och är nu " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1214694703 = messageFormatterFn((function(  ) {
  return function(d) { return "per natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1087066209 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt, gå tillbaka till hotellsidan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2006443719 = messageFormatterFn((function(  ) {
  return function(d) { return "Mer information"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a433339203 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng, gå tillbaka till hotellsidan."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b820226579 = messageFormatterFn((function(  ) {
  return function(d) { return "Något gick fel."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1547141977 = messageFormatterFn((function(  ) {
  return function(d) { return "Försök med en ny sökning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b72609745 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alternativ och boka"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1578457118 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kanske även gillar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b905497775 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng filter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b131372711 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortera och filtrera"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1482919717 = messageFormatterFn((function(  ) {
  return function(d) { return "Klar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1464292070 = messageFormatterFn((function(  ) {
  return function(d) { return "Rensa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b198391171 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicka på \"Tillämpa\" eller gå tillbaka för att stänga filter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a111921919 = messageFormatterFn((function(  ) {
  return function(d) { return "Lägsta pris"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b767235695 = messageFormatterFn((function(  ) {
  return function(d) { return "Maxpris"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1609293258 = messageFormatterFn((function(  ) {
  return function(d) { return "Stjärngradering"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1681721689 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortera efter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a944346854 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtrera din sökning efter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2038995366 = messageFormatterFn((function(  ) {
  return function(d) { return "Tillbaka till hotellsökning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2081504476 = messageFormatterFn((function(  ) {
  return function(d) { return "Söker bland tusentals boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a515050633 = messageFormatterFn((function(  ) {
  return function(d) { return "Söker efter tusentals paketerbjudanden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2122412683 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " filter";}, one: function() { return number(d["0"]) + " filter";}, two: function() { return number(d["0"]) + " filter";}, few: function() { return number(d["0"]) + " filter";}, many: function() { return number(d["0"]) + " filter";}, other: function() { return number(d["0"]) + " filter";} }) + " tillämpas"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2047518133 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortera och filtrera"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a568933793 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtrera"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a903661932 = messageFormatterFn((function(  ) {
  return function(d) { return "Karta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1666478217 = messageFormatterFn((function(  ) {
  return function(d) { return "resultaten hämtas"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1880990506 = messageFormatterFn((function(  ) {
  return function(d) { return "resultaten har uppdaterats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1281544838 = messageFormatterFn((function(  ) {
  return function(d) { return "fel när resultaten hämtades"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a944425190 = messageFormatterFn((function(  ) {
  return function(d) { return "resultaten är tomma"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1920317668 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2073161133 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1361292926 = messageFormatterFn((function(  ) {
  return function(d) { return "Prova dessa datum istället"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b834073549 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a508450632 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa färre datum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b981391161 = messageFormatterFn((function(  ) {
  return function(d) { return "Sökresultat för hotell i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1276093355 = messageFormatterFn((function(  ) {
  return function(d) { return "Sökresultat för semesterboenden i " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1739662298 = messageFormatterFn((function(  ) {
  return function(d) { return "Ogiltiga sökresultat för hotell"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a981755388 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa fler"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1558812830 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kunde inte hitta några resultat. Försök ändra din sökning."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b494924296 = messageFormatterFn((function(  ) {
  return function(d) { return "Valt filter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1852115354 = messageFormatterFn((function(  ) {
  return function(d) { return "Valda filter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1705756966 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination saknas"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a705889062 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a522741894 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort alla filter"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a953806213 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gäster";}, one: function() { return number(d["0"]) + " gäst";}, two: function() { return number(d["0"]) + " gäster";}, few: function() { return number(d["0"]) + " gäster";}, many: function() { return number(d["0"]) + " gäster";}, other: function() { return number(d["0"]) + " gäster";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b628406371 = messageFormatterFn((function(  ) {
  return function(d) { return "Ett problem uppstod hos oss"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a241545910 = messageFormatterFn((function(  ) {
  return function(d) { return "Försök igen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a39237378 = messageFormatterFn((function(  ) {
  return function(d) { return "Spara " + d["0"] + " i dina listor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1843109128 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort " + d["0"] + " från dina listor"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1374967488 = messageFormatterFn((function(  ) {
  return function(d) { return "Uppgifter för din nästa vistelse"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b552769673 = messageFormatterFn((function(  ) {
  return function(d) { return "Sök i det här området"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a800535515 = messageFormatterFn((function(  ) {
  return function(d) { return "Ett fel har tyvärr inträffat. Försök att söka igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b824287692 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng karta"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1720065812 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " boenden";}, one: function() { return number(d["0"]) + " boende";}, two: function() { return number(d["0"]) + " boenden";}, few: function() { return number(d["0"]) + " boenden";}, many: function() { return number(d["0"]) + " boenden";}, other: function() { return number(d["0"]) + " boenden";} }) + "\nfrån " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2038848437 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " boenden";}, one: function() { return number(d["0"]) + " boende";}, two: function() { return number(d["0"]) + " boenden";}, few: function() { return number(d["0"]) + " boenden";}, many: function() { return number(d["0"]) + " boenden";}, other: function() { return number(d["0"]) + " boenden";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1414035004 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa fler"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b388778993 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa mindre"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a811427683 = messageFormatterFn((function(  ) {
  return function(d) { return "Tyvärr gick något snett hos oss"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2000323759 = messageFormatterFn((function(  ) {
  return function(d) { return "Nästa produkt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1287099725 = messageFormatterFn((function(  ) {
  return function(d) { return "Föregående produkt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2136940202 = messageFormatterFn((function(  ) {
  return function(d) { return "Betala"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1066444279 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Din resa (" + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " rum";}, one: function() { return number(d["0"]) + " rum";}, two: function() { return number(d["0"]) + " rum";}, few: function() { return number(d["0"]) + " rum";}, many: function() { return number(d["0"]) + " rum";}, other: function() { return number(d["0"]) + " rum";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1662876672 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Din resa (" + plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " vistelser";}, one: function() { return number(d["0"]) + " vistelse";}, two: function() { return number(d["0"]) + " vistelser";}, few: function() { return number(d["0"]) + " vistelser";}, many: function() { return number(d["0"]) + " vistelser";}, other: function() { return number(d["0"]) + " vistelser";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b825708228 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj ditt nästa rum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b649434471 = messageFormatterFn((function(  ) {
  return function(d) { return "Inte längre tillgängligt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b804913861 = messageFormatterFn((function(  ) {
  return function(d) { return "Ett eller flera boenden under din resa är inte längre tillgängliga. Gå till betalningssidan ändå?"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1343984514 = messageFormatterFn((function(  ) {
  return function(d) { return "per rum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1518000598 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " gäster";}, one: function() { return number(d["0"]) + " gäst";}, two: function() { return number(d["0"]) + " gäster";}, few: function() { return number(d["0"]) + " gäster";}, many: function() { return number(d["0"]) + " gäster";}, other: function() { return number(d["0"]) + " gäster";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1509250862 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["0"]) + " rum";}, one: function() { return number(d["0"]) + " rum";}, two: function() { return number(d["0"]) + " rum";}, few: function() { return number(d["0"]) + " rum";}, many: function() { return number(d["0"]) + " rum";}, other: function() { return number(d["0"]) + " rum";} }) + ", " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " gäster";}, one: function() { return number(d["1"]) + " gäst";}, two: function() { return number(d["1"]) + " gäster";}, few: function() { return number(d["1"]) + " gäster";}, many: function() { return number(d["1"]) + " gäster";}, other: function() { return number(d["1"]) + " gäster";} }); }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1614974075 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/natt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b767007331 = messageFormatterFn((function(  ) {
  return function(d) { return "Byt rum"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1562598583 = messageFormatterFn((function(  ) {
  return function(d) { return "Koden har kopierats till Urklipp"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b529944240 = messageFormatterFn((function(  ) {
  return function(d) { return "Tyvärr uppstod ett problem hos oss"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b653366641 = messageFormatterFn((function(  ) {
  return function(d) { return "Gör om din sökning"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1147817479 = messageFormatterFn((function(  ) {
  return function(d) { return "Försök igen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a947017658 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämtning och avlämning av hyrbil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2022533853 = messageFormatterFn((function(  ) {
  return function(d) { return "Hämtningstid"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2082623023 = messageFormatterFn((function(  ) {
  return function(d) { return "Avlämningstid"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1088786610 = messageFormatterFn((function(  ) {
  return function(d) { return "Hyrbil"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1865948475 = messageFormatterFn((function(  ) {
  return function(d) { return "Avlämningstiden måste ligga minst 2 timmar efter hämtningstiden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a458130023 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a458219396 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a459053544 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a459142917 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a459977065 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a460066438 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a460900586 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a460989959 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a461824107 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a461913480 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a462747628 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a462837001 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a463671149 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a463760522 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a464594670 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a464684043 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a465518191 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a465607564 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a466441712 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a466531085 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a486759174 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a486848547 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a487682695 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a487772068 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a488606216 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a488695589 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a489529737 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a489619110 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a490453258 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a490542631 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a491376779 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a491466152 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a492300300 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a492389673 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a493223821 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a493313194 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a494147342 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a494236715 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a495070863 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a495160236 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a515388325 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a515477698 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a516311846 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a516401219 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a517235367 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a517324740 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a518158888 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a518248261 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a942064744 = messageFormatterFn((function(  ) {
  return function(d) { return "Endast direktflyg"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1357138981 = messageFormatterFn((function(  ) {
  return function(d) { return "Önskad klass"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1881521757 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1254677500 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium Economy"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1603645475 = messageFormatterFn((function(  ) {
  return function(d) { return "Business"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1204700613 = messageFormatterFn((function(  ) {
  return function(d) { return "First Class"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1525787804 = messageFormatterFn((function(  ) {
  return function(d) { return "Gäster"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1011945754 = messageFormatterFn((function(  ) {
  return function(d) { return "Det måste finnas minst en resenär (minst sex år gammal) för varje spädbarn i knät."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a10176289 = messageFormatterFn((function(  ) {
  return function(d) { return "Spädbarn"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1270087126 = messageFormatterFn((function(  ) {
  return function(d) { return "(2–17 år)"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2055913864 = messageFormatterFn((function(  ) {
  return function(d) { return "Under 2 år"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2053402250 = messageFormatterFn((function(  ) {
  return function(d) { return "Ålder på spädbarn " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2023226258 = messageFormatterFn((function(  ) {
  return function(d) { return "Minska antalet spädbarn i rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b100000146 = messageFormatterFn((function(  ) {
  return function(d) { return "Öka antalet spädbarn i rum " + d["0"]; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2057110656 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj om barn under två år ska ha en egen sittplats eller sitta i knät"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b379251672 = messageFormatterFn((function(  ) {
  return function(d) { return "I knät"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a579791354 = messageFormatterFn((function(  ) {
  return function(d) { return "På egen sittplats"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1020247845 = messageFormatterFn((function(  ) {
  return function(d) { return "Flygbolagets åldersregler"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1907077585 = messageFormatterFn((function(  ) {
  return function(d) { return "Från"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1174777545 = messageFormatterFn((function(  ) {
  return function(d) { return "Avresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1135875213 = messageFormatterFn((function(  ) {
  return function(d) { return "Återresa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1613616559 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj en avreseort"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1302121909 = messageFormatterFn((function(  ) {
  return function(d) { return "Jag behöver bara boende under en del av resan"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1043324876 = messageFormatterFn((function(  ) {
  return function(d) { return "Något gick tyvärr snett på vårt håll. Försök igen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a240767456 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj minst 1 till boende för jämförelse"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b525068125 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "/" + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " boenden";}, one: function() { return number(d["1"]) + " boende";}, two: function() { return number(d["1"]) + " boenden";}, few: function() { return number(d["1"]) + " boenden";}, many: function() { return number(d["1"]) + " boenden";}, other: function() { return number(d["1"]) + " boenden";} }) + " har valts"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b22442151 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " av " + plural(d["1"], 0, pluralFuncs["sv-SE"], { zero: function() { return number(d["1"]) + " boenden";}, one: function() { return number(d["1"]) + " boende";}, two: function() { return number(d["1"]) + " boenden";}, few: function() { return number(d["1"]) + " boenden";}, many: function() { return number(d["1"]) + " boenden";}, other: function() { return number(d["1"]) + " boenden";} }) + " har valts för jämförelse"; }
})(messageFormat.number, messageFormat.plural, {"sv-SE": Globalize("sv-SE").pluralGenerator()}), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1346404889 = messageFormatterFn((function(  ) {
  return function(d) { return "Jämför"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1409362795 = messageFormatterFn((function(  ) {
  return function(d) { return "Jämför utvalda boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1028558481 = messageFormatterFn((function(  ) {
  return function(d) { return "Jämför"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1499452941 = messageFormatterFn((function(  ) {
  return function(d) { return "Jämför utvalda boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a539246655 = messageFormatterFn((function(  ) {
  return function(d) { return "Visa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2087569725 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicka för att visa boendet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1112794782 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1177699902 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicka för att ta bort boendet från jämförelsen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b90532684 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng jämförelse av boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a2004812466 = messageFormatterFn((function(  ) {
  return function(d) { return "Jämför boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1400154871 = messageFormatterFn((function(  ) {
  return function(d) { return "Se upp till 5 boenden sida vid sida så att du enklare kan bestämma dig. Välj “Jämför” för att börja."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a454953325 = messageFormatterFn((function(  ) {
  return function(d) { return "Se upp till 5 boenden sida vid sida så att du enklare kan bestämma dig."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b680432933 = messageFormatterFn((function(  ) {
  return function(d) { return "Testa det nu"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a381240841 = messageFormatterFn((function(  ) {
  return function(d) { return "Börja jämföra"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a658009763 = messageFormatterFn((function(  ) {
  return function(d) { return "Inaktiverar jämförelse"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1076708543 = messageFormatterFn((function(  ) {
  return function(d) { return "Kanske senare"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1210555842 = messageFormatterFn((function(  ) {
  return function(d) { return "Jämför boenden"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1937765981 = messageFormatterFn((function(  ) {
  return function(d) { return "Välj “Jämför” i sökresultaten för att börja."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b58971449 = messageFormatterFn((function(  ) {
  return function(d) { return "Se upp till 5 boenden sida vid sida."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1438038032 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " är inte tillgängligt."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a279883981 = messageFormatterFn((function(  ) {
  return function(d) { return "Utcheckning inte tillgänglig " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b726671236 = messageFormatterFn((function(  ) {
  return function(d) { return "Incheckning inte tillgänglig " + d["0"] + "."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1787999122 = messageFormatterFn((function(  ) {
  return function(d) { return "Okej"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a346249910 = messageFormatterFn((function(  ) {
  return function(d) { return "Se alla bekvämligheter på boendet"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b24999365 = messageFormatterFn((function(  ) {
  return function(d) { return "Anpassa din vistelse"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2146181669 = messageFormatterFn((function(  ) {
  return function(d) { return "Stäng avsnittet Anpassa din vistelse"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a703185049 = messageFormatterFn((function(  ) {
  return function(d) { return "Annons"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b340061867 = messageFormatterFn((function(  ) {
  return function(d) { return "Försök igen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b819469318 = messageFormatterFn((function(  ) {
  return function(d) { return "Om den här annonsen"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b129383736 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi har problem med att hämta informationen."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1855544026 = messageFormatterFn((function(  ) {
  return function(d) { return "Vi kan inte tillhandahålla informationen just nu."; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1302418251 = messageFormatterFn((function(  ) {
  return function(d) { return "Avbryt"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b2037312443 = messageFormatterFn((function(  ) {
  return function(d) { return "Avvisa"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b688287811 = messageFormatterFn((function(  ) {
  return function(d) { return "Klar"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.b1692066753 = messageFormatterFn((function(  ) {
  return function(d) { return "Ta bort"; }
})(), Globalize("sv-SE").pluralGenerator({}));
Globalize.a1550149252 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"y/MM/dd","timeSeparator":":"});
Globalize.b919139814 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"E d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"sön","mon":"mån","tue":"tis","wed":"ons","thu":"tors","fri":"fre","sat":"lör"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mars","4":"apr.","5":"maj","6":"juni","7":"juli","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b1713128889 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.a109865639 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"dd/MM/yy","timeSeparator":":"});
Globalize.a142010564 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"dd/MM/y","timeSeparator":":"});
Globalize.a1401985113 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"d/MM/yy","timeSeparator":":"});
Globalize.a1020431450 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a85894522 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"d/M/yy","timeSeparator":":"});
Globalize.b1105688687 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d/M/y","timeSeparator":":"});
Globalize.b102022508 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a1132964369 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"y/M/d","timeSeparator":":"});
Globalize.b1658987865 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a1888690951 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"dd.MM.yy","timeSeparator":":"});
Globalize.b1601723292 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"dd.MM.y","timeSeparator":":"});
Globalize.b867305358 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"d.MM.y","timeSeparator":":"});
Globalize.b525865380 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b1685544964 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"d.M.yy","timeSeparator":":"});
Globalize.b1994115889 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d.M.y","timeSeparator":":"});
Globalize.a138734151 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b598582521 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1604846841 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b627451033 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"dd-MM-yy","timeSeparator":":"});
Globalize.b1075352569 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.a778860058 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a1917559463 = dateToPartsFormatterFn({"2":Globalize("sv-SE").numberFormatter({"raw":"00"}),"4":Globalize("sv-SE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b1458254600 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"S","mon":"M","tue":"T","wed":"O","thu":"T","fri":"F","sat":"L"}}}});
Globalize.b1155449977 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"söndag","mon":"måndag","tue":"tisdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lördag"}}}});
Globalize.a1886271879 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"mars","4":"april","5":"maj","6":"juni","7":"juli","8":"augusti","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a812832580 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"y-MM-dd","timeSeparator":":"});
Globalize.a2044317881 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a1940389690 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"}),"2":Globalize("sv-SE").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1495233863 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mars","4":"apr.","5":"maj","6":"juni","7":"juli","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b911751646 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"mars","4":"april","5":"maj","6":"juni","7":"juli","8":"augusti","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b437476141 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"mars","4":"april","5":"maj","6":"juni","7":"juli","8":"augusti","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b1538193427 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"mars","4":"april","5":"maj","6":"juni","7":"juli","8":"augusti","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b1537508234 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mars","4":"apr.","5":"maj","6":"juni","7":"juli","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a1825018375 = dateToPartsFormatterFn({"1":Globalize("sv-SE").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"söndag","mon":"måndag","tue":"tisdag","wed":"onsdag","thu":"torsdag","fri":"fredag","sat":"lördag"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mars","4":"apr.","5":"maj","6":"juni","7":"juli","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b1667365822 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d"}));
Globalize.a981791002 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"y/M/d"}));
Globalize.b1226133090 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.a1924782846 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd/MM/yy"}));
Globalize.a1187466174 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd-MM-yy"}));
Globalize.b1280274114 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b696638818 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b1459618639 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b1701190031 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b591359138 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd.MM.yy"}));
Globalize.b1998694082 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1334415138 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.b1609427967 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b850440915 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd.MM.y"}));
Globalize.b1991610530 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b305512559 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d/M/yy"}));
Globalize.a1050111326 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b1258712439 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d.MM.y"}));
Globalize.a893292941 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"dd/MM/y"}));
Globalize.a1289051827 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a1548982609 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.b1256862054 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d/M/y"}));
Globalize.a1923092432 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b2076952045 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d.M.yy"}));
Globalize.b533037895 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.a1564114957 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"y-MM-dd"}));
Globalize.b1582251748 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b2145289256 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d.M.y"}));
Globalize.b1159479676 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a1712894699 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1158794483 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a517447902 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a1207287824 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b2141699806 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"d/MM/yy"}));
Globalize.b540426063 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b1993535667 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"y/MM/dd"}));
Globalize.b219868770 = dateFormatterFn(Globalize("sv-SE").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a2131509645 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a1394192973 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a279646605 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a1135401837 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yy","digitsRe":/\d/});
Globalize.a1422018366 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/y","digitsRe":/\d/});
Globalize.b1612974381 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/MM/yy","digitsRe":/\d/});
Globalize.a2045967648 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b149909568 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yy","digitsRe":/\d/});
Globalize.a549272715 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/y","digitsRe":/\d/});
Globalize.a923513690 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b1507041525 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y/M/d","digitsRe":/\d/});
Globalize.a333787629 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b1380740147 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yy","digitsRe":/\d/});
Globalize.b321715490 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.y","digitsRe":/\d/});
Globalize.b1103109448 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.MM.y","digitsRe":/\d/});
Globalize.a499670818 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b1921349054 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yy","digitsRe":/\d/});
Globalize.b339154487 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.y","digitsRe":/\d/});
Globalize.a2092840382 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y-MM-dd","digitsRe":/\d/});
Globalize.b1464810242 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y/MM/dd","digitsRe":/\d/});
Globalize.a387928653 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a398085165 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yy","digitsRe":/\d/});
Globalize.a917422925 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a1804396256 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b384632339 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a196706802 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^T/],["wed",/^O/],["thu",/^T/],["fri",/^F/],["sat",/^L/]]});
Globalize.a1391787853 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^torsdag/],["sun",/^söndag/],["mon",/^måndag/],["tue",/^tisdag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lördag/]]});
Globalize.a138542413 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["12",/^december/],["11",/^november/],["2",/^februari/],["1",/^januari/],["8",/^augusti/],["10",/^oktober/],["4",/^april/],["6",/^juni/],["3",/^mars/],["7",/^juli/],["5",/^maj/]]});
Globalize.a1069814451 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1704585600 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1072882367 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["12",/^dec\./],["11",/^nov\./],["4",/^apr\./],["10",/^okt\./],["9",/^sep\./],["2",/^feb\./],["8",/^aug\./],["6",/^juni/],["3",/^mars/],["7",/^juli/],["5",/^maj/]]});
Globalize.a1081023848 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["12",/^december/],["11",/^november/],["2",/^februari/],["1",/^januari/],["8",/^augusti/],["10",/^oktober/],["4",/^april/],["6",/^juni/],["3",/^mars/],["7",/^juli/],["5",/^maj/]]});
Globalize.a1209022029 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["12",/^december/],["11",/^november/],["2",/^februari/],["1",/^januari/],["8",/^augusti/],["10",/^oktober/],["4",/^april/],["6",/^juni/],["3",/^mars/],["7",/^juli/],["5",/^maj/]]});
Globalize.a454582067 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["12",/^december/],["11",/^november/],["2",/^februari/],["1",/^januari/],["8",/^augusti/],["10",/^oktober/],["4",/^april/],["6",/^juni/],["3",/^mars/],["7",/^juli/],["5",/^maj/]]});
Globalize.a455267260 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["12",/^dec\./],["11",/^nov\./],["4",/^apr\./],["10",/^okt\./],["9",/^sep\./],["2",/^feb\./],["8",/^aug\./],["6",/^juni/],["3",/^mars/],["7",/^juli/],["5",/^maj/]]});
Globalize.b733172479 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^torsdag/],["sun",/^söndag/],["mon",/^måndag/],["tue",/^tisdag/],["wed",/^onsdag/],["fri",/^fredag/],["sat",/^lördag/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["12",/^dec\./],["11",/^nov\./],["4",/^apr\./],["10",/^okt\./],["9",/^sep\./],["2",/^feb\./],["8",/^aug\./],["6",/^juni/],["3",/^mars/],["7",/^juli/],["5",/^maj/]]});
Globalize.a1073635680 = dateParserFn(Globalize("sv-SE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["thu",/^tors/],["sun",/^sön/],["mon",/^mån/],["tue",/^tis/],["wed",/^ons/],["fri",/^fre/],["sat",/^lör/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["12",/^dec\./],["11",/^nov\./],["4",/^apr\./],["10",/^okt\./],["9",/^sep\./],["2",/^feb\./],["8",/^aug\./],["6",/^juni/],["3",/^mars/],["7",/^juli/],["5",/^maj/]]});
module.exports = Globalize;
